import { render, staticRenderFns } from "./ManageProductsAndServicesCatalogue.vue?vue&type=template&id=06b1dba3&scoped=true"
import script from "./ManageProductsAndServicesCatalogue.vue?vue&type=script&lang=js"
export * from "./ManageProductsAndServicesCatalogue.vue?vue&type=script&lang=js"
import style0 from "./ManageProductsAndServicesCatalogue.vue?vue&type=style&index=0&id=06b1dba3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06b1dba3",
  null
  
)

export default component.exports